import { store } from "../store";

export function getToken() {
  const token = store.getState().auth.token;
  return { Authorization: `Token ${token}` };
}
